
// // export default CustomerReport;
// import React, { useState, useEffect } from "react";
// import "../assets/CustomerReport.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCustomers, deleteCustomer } from "../redux/slices/customerReportSlice";
// import CustomerEditModal from "../modals/CustomerEditModal";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";





// const CustomerReport = () => {
//   const dispatch = useDispatch();
//   const { customers, loading, pagination } = useSelector((state) => state.customers);

//   const [filterType, setFilterType] = useState("userId");
//   const [filterValue, setFilterValue] = useState("");
//   const [branch, setBranch] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [customerPhotos, setCustomerPhotos] = useState({});
//   const [filters, setFilters] = useState({
//     customerId: "",
//   });

//   const uniqueBranches = [...new Set(customers.map((c) => c.branchId))];

//   useEffect(() => {
//     dispatch(fetchCustomers({ page: pagination.currentPage, limit: pagination.limit , userId:filters.customerId || undefined}));
//   }, [dispatch, pagination.currentPage, pagination.limit,filters.customerId]);

//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete this customer?")) {
//       dispatch(deleteCustomer(id));
//     }
//   };

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= pagination.totalPages) {
//       dispatch(fetchCustomers({ page, limit: pagination.limit ,userId: filters.customerId || undefined, }));
//     }
//   };
//   const superAdminId=localStorage.getItem("adminuserId");
//   const fetchCustomerPhoto = async (userId) => {
//     try {
//       if (!userId || customerPhotos[userId]) return;

//       const res = await fetch(
//         `https://narrowitsolution.in/api/list-kyc?userId=${userId}&superAdminId=${superAdminId}`
//       );

//       if (!res.ok) return;

//       const data = await res.json();

//       const photoDoc = data?.documents?.find(
//         (doc) => doc?.docName?.toLowerCase() === "photo"
//       );

//       if (photoDoc?.docImage) {
//         setCustomerPhotos((prev) => ({
//           ...prev,
//           [userId]: `https://narrowitsolution.in/uploads/${photoDoc.docImage}`,
//         }));
//       }
//     } catch (err) {
//       console.error("Photo fetch error:", err);
//     }
//   };

//    useEffect(() => {
//       if (!superAdminId || !customers.length) return;
  
//       customers.forEach((c) => {
//         if (c.userId && !customerPhotos[c.userId]) {
//           fetchCustomerPhoto(c.userId);
//         }
//       });
//     }, [customers,superAdminId]);
  
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

// const downloadPDF = () => {
//   if (!customers || customers.length === 0) {
//     alert("No data to export");
//     return;
//   }

//   const doc = new jsPDF("l", "mm", "a4");

//   doc.text("Customer Report", 14, 15);

//   const tableHead = [[
//     "SN",
//     "User ID",
//     // "Consumer ID",
//     "Emp Search ID",
//     "Name",
//     "Email",
//     "Mobile",
//     "Aadhaar",
//     "PAN",
//     "DOB",
//     "Joining Date",
//   ]];

//   const tableBody = customers.map((row, index) => [
//     (pagination.currentPage - 1) * pagination.limit + index + 1,
//     row.userId,
//     // row.consumerno ?? "N/A",
//     row.branchId,
//     row.fullName,
//     row.email,
//     row.mobileNumber,
//     row.aadhaarNumber,
//     row.panNumber,
//     row.dateOfBirth?.slice(0, 10),
//     row.dateOfJoining?.slice(0, 10),
//   ]);

//   autoTable(doc, {
//     head: tableHead,
//     body: tableBody,
//     startY: 20,
//     styles: { fontSize: 8 },
//     theme: "grid",
//   });

//   doc.save(`Customer_Report_${Date.now()}.pdf`);
// };





// const handleLimitChange = (e) => {
//   const newLimit = parseInt(e.target.value);

//   dispatch(
//     fetchCustomers({
//       page: 1,
//       limit: newLimit,
//       userId: filters.customerId || undefined,
//     })
//   );
// };



//   const downloadExcel = () => {
//   if (!customers || customers.length === 0) {
//     alert("No data to export");
//     return;
//   }

//   const excelData = customers.map((row, index) => ({
//     "SN": (pagination.currentPage - 1) * pagination.limit + index + 1,
//     "User ID": row.userId,
//     "Consumer ID": row.consumerno ?? "N/A",
//     "Employee Search ID": row.branchId,
//     "Name": row.fullName,
//     "Email": row.email,
//     "Mobile": row.mobileNumber,
//     "Aadhaar": row.aadhaarNumber,
//     "PAN": row.panNumber,
//     "Address": row.address,
//     "DOB": row.dateOfBirth?.slice(0, 10),
//     "Joining Date": row.dateOfJoining?.slice(0, 10),
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(excelData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: "xlsx",
//     type: "array",
//   });

//   const file = new Blob([excelBuffer], {
//     type:
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });

//   saveAs(file, `Customer_Report_${Date.now()}.xlsx`);
// };


//   // Generate pagination buttons
//   const filteredData=customers;

//   const pageNumbers = [];
//   for (let i = 1; i <= pagination.totalPages; i++) pageNumbers.push(i);

//   return (
//     <div className="CustomerReport-container">
//       <h2 className="CustomerReport-heading">Customer Report</h2>

//       {/* Filter Section */}
//       <div className="CustomerReport-filterSection">
//         <div className="CustomerReport-filterGroup">
//           <label htmlFor="fromDate">From Date</label>
//           <input
//             id="fromDate"
//             type="date"
//             className="CustomerReport-input"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//           />
//         </div>

//         <div className="CustomerReport-filterGroup">
//           <label htmlFor="toDate">To Date</label>
//           <input
//             id="toDate"
//             type="date"
//             className="CustomerReport-input"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//           />
//         </div>

//         {/* {
        
//         <div className="CustomerReport-filterGroup">
//           <label htmlFor="branch">Branch</label>
//           <select
//             id="branch"
//             className="CustomerReport-input"
//             value={branch}
//             onChange={(e) => setBranch(e.target.value)}
//           >
//             <option value="">Select Emp.</option>
//             {uniqueBranches.map((b, i) => (
//               <option key={i} value={b}>
//                 {b}
//               </option>
//             ))}
//           </select>
//         </div> 
        
//         } */}

//         {/* <div className="CustomerReport-filterGroup">
//           <label htmlFor="filterType">Filter By</label>
//           <select
//             id="filterType"
//             className="CustomerReport-input"
//             value={filterType}
//             onChange={(e) => setFilterType(e.target.value)}
//           >
//             <option value="userId">User ID</option>
//             <option value="aadhar">Aadhar</option>
//             <option value="pan">PAN</option>
//             <option value="phone">Mobile</option>
//             <option value="dob">DOB</option>
//           </select>
//         </div>

//         <div className="CustomerReport-filterGroup">
//           <label htmlFor="filterInput">{filterType.toUpperCase()}</label>
//           <input
//             id="filterInput"
//             className="CustomerReport-input"
//             type={filterType === "dob" ? "date" : "text"}
//             placeholder={`Enter ${filterType.toUpperCase()}`}
//             value={filterValue}
//             onChange={(e) => setFilterValue(e.target.value)}
//           />
//         </div> */}

//         <section className="CustomerReport-filterGroup">
//         <div className="BranchCustomerReport-filter-form">
//           <div className="BranchCustomerReport-filter-form-group">
//             <label>Customer Id</label>
//             <input
//               className="CustomerReport-input"
//               type="text"
//               name="customerId"
//               placeholder="Enter customer id"
//               value={filters.customerId}
//               onChange={handleInputChange}
//             />
//           </div>
//         </div>
//       </section>

//         <div className="CustomerReport-filterGroup buttonWrapper">
//           <button className="CustomerReport-submit" onClick={() => {}}>
//             Submit
//           </button>
//         </div>
//       </div>


//       <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
//   <button className="CustomerReport-submit" onClick={downloadExcel}>
//     ⬇️  Excel
//   </button>

//   <button className="CustomerReport-submit" onClick={downloadPDF}>
//     ⬇️  PDF
//   </button>
// </div>



// <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
  
//   <div>
//     <label style={{ marginRight: "8px" }}>Show</label>

//     <select
//       value={pagination.limit}
//       onChange={handleLimitChange}
//       className="CustomerReport-input"
//       style={{ width: "80px" }}
//     >
//       <option value={25}>25</option>
//       <option value={50}>50</option>
//       <option value={100}>100</option>
//     </select>

//     <span style={{ marginLeft: "8px" }}>entries</span>
//   </div>

// </div>


//       {/* Table Section */}
//       <div className="CustomerReport-tableWrapper">
//         <table className="CustomerReport-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Profile</th>
//               <th>User ID</th>
//                <th>consumer ID</th>
//               <th>Emp. search ID</th>
//               <th>User Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               {/* <th>Branch Id</th> */}
//               {/* <th>Role</th> */}
//               <th>Aadhar</th>
//               <th>PAN</th>
//               <th>Address</th>
//               <th>DOB</th>
//               <th>Joining Date</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="15" style={{ textAlign: "center" }}>
//                   Loading...
//                 </td>
//               </tr>
//             ) : filteredData.length > 0 ? (
//               filteredData.map((row, index) => (
//                 <tr key={row.id}>
//                  <td>{(pagination.currentPage - 1) * pagination.limit + index + 1}</td>
//                   {/* <td>
//                     <img
//                       src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
//                         row.fullName || ""
//                       )}&background=random`}
//                       alt="Profile"
//                     />
//                   </td> */}
//                    <td>
//                     <img
//                       src={
//                         customerPhotos[row.userId] ||
//                         "/default-avatar.png"
//                       }
//                       alt="N/A"
//                       width="40"
//                       height="40"
//                       style={{ borderRadius: "50%" }}
//                     />
//                   </td>
                  
//                   <td>{row.userId}</td>
//                   <td>{row.consumerno ?? "N/A"}</td>

//                   <td>{row.branchId}</td>
//                   <td>{row.fullName}</td>
//                   <td>{row.email}</td>
//                   <td>{row.mobileNumber}</td>
//                   {/* <td>{row.branchName}</td>
//                   <td>{row.roleName}</td> */}
//                   <td>{row.aadhaarNumber}</td>
//                   <td>{row.panNumber}</td>
//                   <td>{row.address}</td>
//                   <td>{row.dateOfBirth?.slice(0, 10)}</td>
//                   <td>{row.dateOfJoining?.slice(0, 10)}</td>
//                  <td>
//                     <button
//                       className="CustomerReport-edit"
//                       onClick={() => {
//                         setIsModalOpen(true);
//                         setSelectedCustomer(row);
//                       }}
//                       title="Edit"
//                     >
//                       <i className="fas fa-edit"></i>
//                     </button>
//                   </td>

//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="15" style={{ textAlign: "center" }}>
//                   No records found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {pagination.totalPages > 1 && (
//   <div className="CustomerReport-pagination">
//     <button
//       onClick={() => handlePageChange(pagination.currentPage - 1)}
//       disabled={pagination.currentPage === 1}
//     >
//       Prev
//     </button>

//     <span className="CustomerReport-pageIndicator">
//       Page {pagination.currentPage} of {pagination.totalPages}
//     </span>

//     <button
//       onClick={() => handlePageChange(pagination.currentPage + 1)}
//       disabled={pagination.currentPage === pagination.totalPages}
//     >
//       Next
//     </button>
//   </div>
// )}


//       {/* Edit Modal */}
//       <CustomerEditModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         customer={selectedCustomer}
//       />
//     </div>
//   );
// };

// export default CustomerReport;



import React, { useState, useEffect } from "react";
import "../assets/CustomerReport.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers, deleteCustomer } from "../redux/slices/customerReportSlice";
import CustomerEditModal from "../modals/CustomerEditModal";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const CustomerReport = () => {

  const dispatch = useDispatch();

  const { customers, loading, pagination } = useSelector(
    (state) => state.customers
  );

  const [filters, setFilters] = useState({
    customerId: ""
  });

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [customerPhotos, setCustomerPhotos] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const superAdminId = localStorage.getItem("adminuserId");

  /* -------------------- FETCH CUSTOMERS -------------------- */

  useEffect(() => {

    dispatch(
      fetchCustomers({
        page: pagination.currentPage,
        limit: pagination.limit,
        userId: filters.customerId || undefined
      })
    );

  }, [dispatch, pagination.currentPage, pagination.limit, filters.customerId]);


  /* -------------------- PAGE CHANGE -------------------- */

  const handlePageChange = (page) => {

    if (page >= 1 && page <= pagination.totalPages) {

      dispatch(
        fetchCustomers({
          page,
          limit: pagination.limit,
          userId: filters.customerId || undefined
        })
      );

    }

  };


  /* -------------------- LIMIT CHANGE -------------------- */

  const handleLimitChange = (e) => {

    const newLimit = parseInt(e.target.value);

    dispatch(
      fetchCustomers({
        page: 1,
        limit: newLimit,
        userId: filters.customerId || undefined
      })
    );

  };


  /* -------------------- INPUT CHANGE -------------------- */

  const handleInputChange = (e) => {

    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value
    }));

  };


  /* -------------------- CUSTOMER PHOTO FETCH -------------------- */

  const fetchCustomerPhoto = async (userId) => {

    try {

      if (!userId || customerPhotos[userId]) return;

      const res = await fetch(
        `https://narrowitsolution.in/api/list-kyc?userId=${userId}&superAdminId=${superAdminId}`
      );

      if (!res.ok) return;

      const data = await res.json();

      const photoDoc = data?.documents?.find(
        (doc) => doc?.docName?.toLowerCase() === "photo"
      );

      if (photoDoc?.docImage) {

        setCustomerPhotos((prev) => ({
          ...prev,
          [userId]: `https://narrowitsolution.in/uploads/${photoDoc.docImage}`
        }));

      }

    } catch (err) {

      console.error("Photo fetch error:", err);

    }

  };


  useEffect(() => {

    if (!superAdminId || !customers.length) return;

    customers.forEach((c) => {

      if (c.userId && !customerPhotos[c.userId]) {

        fetchCustomerPhoto(c.userId);

      }

    });

  }, [customers, superAdminId]);


  /* -------------------- PDF DOWNLOAD -------------------- */

  const downloadPDF = () => {

    if (!customers.length) return alert("No data to export");

    const doc = new jsPDF("l", "mm", "a4");

    doc.text("Customer Report", 14, 15);

    const tableHead = [[
      "SN",
      "User ID",
      "Employee ID",
      "Employee Name",
      "Name",
      "Email",
      "Mobile",
      "Aadhaar",
      "PAN",
      "DOB",
      "Joining Date"
    ]];

    const tableBody = customers.map((row, index) => [

      (pagination.currentPage - 1) * pagination.limit + index + 1,
      row.userId,
      row["employee"]?.userId ?? "N/A",
      row["employee"]?.fullName ?? "N/A",
      row.email,
      row.mobileNumber,
      row.aadhaarNumber,
      row.panNumber,
      row.dateOfBirth?.slice(0, 10),
      row.dateOfJoining?.slice(0, 10)

    ]);

    autoTable(doc, {
      head: tableHead,
      body: tableBody,
      startY: 20,
      styles: { fontSize: 8 }
    });

    doc.save(`Customer_Report_${Date.now()}.pdf`);

  };


  /* -------------------- EXCEL DOWNLOAD -------------------- */

  const downloadExcel = () => {

    if (!customers.length) return alert("No data to export");

    const excelData = customers.map((row, index) => ({
      SN: (pagination.currentPage - 1) * pagination.limit + index + 1,
      "User ID": row.userId,
      "Consumer ID": row.consumerno ?? "N/A",
      "Employee ID": row["employee"]?.userId ?? "N/A",
      "Employee Name": row["employee"]?.fullName ?? "N/A",
      Name: row.fullName,
      Email: row.email,
      Mobile: row.mobileNumber,
      Aadhaar: row.aadhaarNumber,
      PAN: row.panNumber,
      Address: row.address,
      DOB: row.dateOfBirth?.slice(0, 10),
      "Joining Date": row.dateOfJoining?.slice(0, 10)
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(file, `Customer_Report_${Date.now()}.xlsx`);

  };


  /* -------------------- UI -------------------- */

  return (

    <div className="CustomerReport-container">

      <h2 className="CustomerReport-heading">Customer Report</h2>

      {/* FILTER */}

      <div className="CustomerReport-filterSection">

        <div className="CustomerReport-filterGroup">

          <label>Customer Id</label>

          <input
            type="text"
            name="customerId"
            placeholder="Enter customer id"
            className="CustomerReport-input"
            value={filters.customerId}
            onChange={handleInputChange}
          />

        </div>

      </div>


      {/* EXPORT */}

      <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>

        <button className="CustomerReport-submit" onClick={downloadExcel}>
          Excel
        </button>

        <button className="CustomerReport-submit" onClick={downloadPDF}>
          PDF
        </button>

      </div>


      {/* SHOW LIMIT */}

      <div style={{ marginBottom: "10px" }}>

        <label>Show </label>

        <select
          value={pagination.limit}
          onChange={handleLimitChange}
          className="CustomerReport-input"
          style={{ width: "80px" }}
        >
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>

        <span> entries</span>

      </div>


      {/* TABLE */}

      <div className="CustomerReport-tableWrapper">

        <table className="CustomerReport-table">

          <thead>

            <tr>
              <th>SN</th>
              <th>Profile</th>
              <th>User ID</th>
              <th>Consumer ID</th>
              <th>Employee ID</th>
              <th>Emp. Name</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Aadhaar</th>
              <th>PAN</th>
              <th>Address</th>
              <th>DOB</th>
              <th>Joining Date</th>
              <th>Action</th>
            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>
                <td colSpan="14">Loading...</td>
              </tr>

            ) : customers.length ? (

              customers.map((row, index) => (

                <tr key={row.id}>

                  <td>
                    {(pagination.currentPage - 1) * pagination.limit +
                      index +
                      1}
                  </td>

                  <td>

                    <img
                      src={customerPhotos[row.userId] || "/default-avatar.png"}
                      alt="profile"
                      width="40"
                      height="40"
                      style={{ borderRadius: "50%" }}
                    />

                  </td>

                  <td>{row.userId}</td>
                  <td>{row.consumerno ?? "N/A"}</td>
                  <td>{row["employee"]?.userId ?? "N/A"}</td>
                  <td>{row["employee"]?.fullName ?? "N/A"}</td>
                  <td>{row.fullName}</td>
                  <td>{row.email}</td>
                  <td>{row.mobileNumber}</td>
                  <td>{row.aadhaarNumber}</td>
                  <td>{row.panNumber}</td>
                  <td>{row.address}</td>
                  <td>{row.dateOfBirth?.slice(0, 10)}</td>
                  <td>{row.dateOfJoining?.slice(0, 10)}</td>

                  <td>

                    <button
                      className="CustomerReport-edit"
                      onClick={() => {
                        setSelectedCustomer(row);
                        setIsModalOpen(true);
                      }}
                    >
                      Edit
                    </button>

                  </td>

                </tr>

              ))

            ) : (

              <tr>
                <td colSpan="14">No records found</td>
              </tr>

            )}

          </tbody>

        </table>

      </div>


      {/* PAGINATION */}

      {pagination.totalPages > 1 && (

        <div className="CustomerReport-pagination">

          <button
            onClick={() =>
              handlePageChange(pagination.currentPage - 1)
            }
            disabled={pagination.currentPage === 1}
          >
            Prev
          </button>

          <span>
            Page {pagination.currentPage} of {pagination.totalPages}
          </span>

          <button
            onClick={() =>
              handlePageChange(pagination.currentPage + 1)
            }
            disabled={
              pagination.currentPage === pagination.totalPages
            }
          >
            Next
          </button>

        </div>

      )}


      {/* EDIT MODAL */}

      <CustomerEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        customer={selectedCustomer}
      />

    </div>

  );

};

export default CustomerReport;